//import { GET_JOB_DETAILS_INFO } from '../constants/actionTypes';
//import { PENDING, SUCCESS, ERROR } from '../constants/status';
import {
  GET_JOB_DETAILS_REQUEST,
  GET_JOB_DETAILS_SUCCESS,
  GET_JOB_DETAILS_FAILURE
} from 'constants/actionTypes';
import { listTableDetails } from 'utils/utils';

export const initialState = {
  isProcessingJobDetails: false,
  fetchedJobDetailsData: null,
  fetchedJobDetailsError: null
};

const jobDetail = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_JOB_DETAILS_REQUEST:
      return {
        ...state,
        isProcessingJobDetails: true,
        fetchedJobDetailsData: null
      };
    case GET_JOB_DETAILS_SUCCESS:
      return {
        fetchedJobDetailsData: payload.fetchedJobDetailsData,
        isProcessingJobDetails: false,
        fetched: true,
        error: null
      };
    case GET_JOB_DETAILS_FAILURE:
      return {
        ...state,
        fetchedJobDetailsData: listTableDetails,
        isProcessingJobDetails: false
      };
    default: {
      return state;
    }
  }
};

export default jobDetail;
